<template>
  <div>
    <PageHeader page-name="Социальные сети">
      <template>
        <router-link :to="{name: 'CreateSocial'}">
          <el-button type="primary">
            Создать социальную сеть
          </el-button>
        </router-link>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" />
    </MainPanel>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import List from '@/components/socials/List'
import MainPanel from '@/components/common/MainPanel'
import PageHeader from '@/components/common/PageHeader';

export default {
  name: 'SocialsListPage',
  components: {MainPanel, List, PageHeader},
  metaInfo: {
    title: 'Социальные сети',
  },
  data() {
    return {
      loading: false,
    }
  },
  async mounted() {
    this.loading = true
    await this.getModel()
    this.loading = false
  },
  methods: {
    ...mapActions('socials', {
      getModel: 'fetchSocialsList',
    }),
  },
}
</script>

<style lang="sass" scoped>
.socials-list
  padding: 20px

.socials-list__header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 20px

.socials-list__title
  margin: 0
  font-size: 24px
  font-weight: 500

.socials-list__table
  margin-top: 20px

.socials-list__image
  max-width: 50px
  max-height: 50px
  object-fit: contain
</style>
